import { createSlice } from "@reduxjs/toolkit";
import APIService from "../services/api.service";
import { AppDispatch } from "../store";

const initialState = {
  factorDialogOpen: false,
  factorId: null,
  description: null,
  detailedDescription: null,
  comment: null,
  opportunityKiller: 0,
  positiveImpact: 1,
  negativeImpact: 1,
  concernings: [],
  probability: 2,
  confidenceIndice: 1,
  preMove: null,
  contMove: null,
  order: null,
  factorIsLoading: false,
  factorStatus: null,
  factorNextAction: null,
  isEditabled: true,
  isDuplicated: false,
  selectedConcernings: [],
  selectedPreventiveMoves: [],
  selectedContingencyMoves: [],
  selectedBoosterMoves: [],
};

export const factorSlice = createSlice({
  name: "factor",
  initialState,
  reducers: {
    openFactorDialog: (state, action) => {
      console.log('FACTOR SLICE', action.payload);
      state.factorDialogOpen = true;

      // init
      state.factorId = null;
      state.description = null;
      state.detailedDescription = null;
      state.comment = null;
      state.opportunityKiller = 0;
      state.positiveImpact = 1;
      state.negativeImpact = 1;
      state.concernings = [];
      state.probability = 2;
      state.confidenceIndice = 1;
      state.preMove = null;
      state.contMove = null;
      state.selectedConcernings = [];
      state.selectedPreventiveMoves = [];
      state.selectedContingencyMoves = [];
      state.selectedBoosterMoves = [];
      // Other
      state.isEditabled = true;
      state.isDuplicated = false;

      // if (action.payload!== undefined && action.payload!== null && Object.is(action.payload, {})) {
      if (action.payload.element.id) {
        // Element
        if (action.payload.isDuplicated === true) {
          state.factorId = null;
          state.description = `${action.payload.element.description} - copy`;
        } else {
          state.factorId = action.payload.element.id;
          state.description = action.payload.element.description;
        }
        state.detailedDescription = action.payload.element.detailed_description;
        state.comment = action.payload.element.comment;
        state.opportunityKiller = action.payload.element.opportunity_killer;
        state.positiveImpact = action.payload.element.positive_impact;
        state.negativeImpact = action.payload.element.negative_impact;
        state.concernings = action.payload.element.concernings;
        // Convert concernings objects to strings for selectedConcernings
        const concerningsArray = action.payload.element.concernings || [];
        state.selectedConcernings = concerningsArray.map(concerning => {
          if (typeof concerning === 'object' && concerning !== null) {
            return concerning.value || concerning.id || concerning;
          }
          return concerning;
        });
        state.probability = action.payload.element.probability;
        state.confidenceIndice = action.payload.element.confidence_indice;
        state.preMove = action.payload.element.pre_move;
        state.contMove = action.payload.element.cont_move;

        // Handle preventive moves
        const preventiveMovesArray = action.payload.element.selected_preventive_moves || [];
        state.selectedPreventiveMoves = preventiveMovesArray.map(move => {
          if (typeof move === 'object' && move !== null) {
            return { id: move.id, name: move.name };
          }
          return move;
        });

        // Handle contingency moves
        const contingencyMovesArray = action.payload.element.selected_contingency_moves || [];
        state.selectedContingencyMoves = contingencyMovesArray.map(move => {
          if (typeof move === 'object' && move !== null) {
            return { id: move.id, name: move.name };
          }
          return move;
        });

        // Handle booster moves
        const boosterMovesArray = action.payload.element.selected_booster_moves || [];
        state.selectedBoosterMoves = boosterMovesArray.map(move => {
          if (typeof move === 'object' && move !== null) {
            return { id: move.id, name: move.name };
          }
          return move;
        });

        // Other
        state.isEditabled = action.payload.isEditabled;
        state.isDuplicated = action.payload.isDuplicated;
      }
    },
    closeFactorDialog: (state) => {
      state.factorDialogOpen = false;
    },
    loadingFactor: (state) => {
      state.factorIsLoading = true;
    },
    resetFactor: (state, action) => {
      state.factorId = null;
      state.description = null;
      state.detailedDescription = null;
      state.comment = null;
      state.opportunityKiller = 0;
      state.positiveImpact = 1;
      state.negativeImpact = 1;
      state.concernings = [];
      state.probability = 2;
      state.confidenceIndice = 1;
      state.preMove = null;
      state.contMove = null;
      state.factorIsLoading = false;
      state.factorStatus = 'success';
      state.factorNextAction = action.payload;
      state.selectedConcernings = [];
      state.selectedPreventiveMoves = [];
      state.selectedContingencyMoves = [];
      state.selectedBoosterMoves = [];
    },
    resetFactorStatus: (state) => {
      state.factorStatus = null;
      state.factorNextAction = null;
    },
    addSelectedConcerning: (state, action) => {
      state.selectedConcernings.push(action.payload);
    },
    removeSelectedConcerning: (state, action) => {
      state.selectedConcernings = state.selectedConcernings.filter(concerning => concerning !== action.payload);
    },
    clearSelectedConcernings: (state) => {
      state.selectedConcernings = [];
    },
    addSelectedPreventiveMove: (state, action) => {
      state.selectedPreventiveMoves.push(action.payload);
    },
    removeSelectedPreventiveMove: (state, action) => {
      state.selectedPreventiveMoves = state.selectedPreventiveMoves.filter(move => move.id !== action.payload);
    },
    clearSelectedPreventiveMoves: (state) => {
      state.selectedPreventiveMoves = [];
    },
    addSelectedContingencyMove: (state, action) => {
      state.selectedContingencyMoves.push(action.payload);
    },
    removeSelectedContingencyMove: (state, action) => {
      state.selectedContingencyMoves = state.selectedContingencyMoves.filter(move => move.id !== action.payload);
    },
    clearSelectedContingencyMoves: (state) => {
      state.selectedContingencyMoves = [];
    },
    addSelectedBoosterMove: (state, action) => {
      state.selectedBoosterMoves.push(action.payload);
    },
    removeSelectedBoosterMove: (state, action) => {
      state.selectedBoosterMoves = state.selectedBoosterMoves.filter(move => move.id !== action.payload);
    },
    clearSelectedBoosterMoves: (state) => {
      state.selectedBoosterMoves = [];
    },
  },
});

export const {
  openFactorDialog,
  closeFactorDialog,
  loadingFactor,
  resetFactor,
  resetFactorStatus,
  addSelectedConcerning,
  removeSelectedConcerning,
  clearSelectedConcernings,
  addSelectedPreventiveMove,
  removeSelectedPreventiveMove,
  clearSelectedPreventiveMoves,
  addSelectedContingencyMove,
  removeSelectedContingencyMove,
  clearSelectedContingencyMoves,
  addSelectedBoosterMove,
  removeSelectedBoosterMove,
  clearSelectedBoosterMoves
} = factorSlice.actions;

export default factorSlice.reducer;

export const factorPost = (nextAction, data: any, id: any = null) => async (dispatch: AppDispatch) => {
  try {
    dispatch(loadingFactor());
    if (id !== null && id !== undefined) {
      await APIService.put(`/factors/${id}`, data).then((response) => {
        dispatch(resetFactor(nextAction));
      });
    } else {
      await APIService.post("/factors", data).then((response) => {
        dispatch(resetFactor(nextAction));
      });
    }
  } catch (e) {
    console.log(e);
    // dispatch(setCustomerError());
  }
};

export const factorDelete = (id: string) => async (dispatch: AppDispatch) => {
  try {
    await APIService.delete(`/factors/${id}`).then((response) => {
      console.log(response);
    });
  } catch (e) {
    console.log(e);
  }
};
